import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'currencyinput'})
export class CurrencyInput implements PipeTransform {
    transform(val: string): string {
        let numericVal=parseInt(val);
        if(numericVal){
            return Number(numericVal).toLocaleString("de-AT", {minimumFractionDigits: 0});
        }else{
            return '';
        }
      }
}